const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
// @ commons
const OKModal = require('components/commons/OKModal/OKModal');

class InformationModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = { isOpen: this.props.openModal };
        this.handleOnRequestClose = this.handleOnRequestClose.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ isOpen: nextProps.openModal });
    }

    handleOnRequestClose() {
        const { handleAction, component, contractWizard, updateCardDetails } = this.props;
        let newContractWizard;
        contractWizard.find(modal => modal.id === component.id).openModal = false;
        if (handleAction) {
            newContractWizard = handleAction(contractWizard);
        }
        updateCardDetails(newContractWizard || contractWizard);
    }

    
    
    render() {
        const { title, content, component, onClosed, onContinue } = this.props;
        const onRequestClose = this.handleOnRequestClose;
        const { isOpen } = this.state;
        const footerType = component.footerType && component.footerType === "navigation" ? "navigation" : "action";
        function onClose(){
            onClosed()
            onRequestClose()
        }
    
        function onNext(){
            onContinue();
            onRequestClose();
        }
        return (
            <OKModal
                content={content}
                footerType={footerType}
                isOpen={isOpen}
                onCloseCallback={onClose}
                onPrimaryButtonClick={onNext}
                primaryButtonText={component.buttonText}
                title={title}
            />
        )
    }
}

InformationModal.defaultProps = {
    onClosed: ()=>{},
    onContinue: ()=>{},
};


InformationModal.propTypes = {
    openModal: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    component: PropTypes.object.isRequired,
    handleAction: PropTypes.func,
    contractWizard: PropTypes.array.isRequired,
    updateCardDetails: PropTypes.func.isRequired,
    onContinue: PropTypes.func,
    onClosed: PropTypes.func,

};

module.exports = InformationModal;
